module.exports = "<div class=\"searchbar\">\n  <form ng-submit=\"$ctrl.doSearch(true)\">\n    <input type=\"search\" ng-model=\"$ctrl.searchText\" ng-change=\"$ctrl.doSearch(false)\" placeholder=\"{{$ctrl.searchPlaceholder | translate}}\" ng-disabled=\"$ctrl.isDisabled\"/>\n  </form>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/searchbar/searchbar.html
 ** module id = 360
 ** module chunks = 0
 **/